import { ENCRYPTION_MODE, ENCRYPTION_MODE_TYPE } from "./encryption-mode";
import { APP_INITIALIZER, inject, Provider } from "@angular/core";
import { LOCATION_READY } from "@core/location-required/location-required.factory";
import { firstValueFrom } from "rxjs";
import { config } from "@core/services/request-url.service";
import { HttpApiService } from "@core/auth/http-api.service";


export function initEncryption(_HttpApiService: HttpApiService, ENCRYPTION_MODE: ENCRYPTION_MODE_TYPE,
    locationReady: Promise<void>) {
    return async () => {
        // 🕐 Wait for location initialization (if provided)
        if (locationReady) await locationReady;

        try {

            // 🔐 Fetch encryption configuration from API
            const response: any = await firstValueFrom(
                _HttpApiService.post(config.auth['shouldApiEncryptDecrypt'])
            );

            const encryptionMode = response?.data?.encrypt ? 1 : 0;
            ENCRYPTION_MODE.set(encryptionMode);

        } catch (err) {
            ENCRYPTION_MODE.set(0);
        }
    };
}



export const ENCRYPTION_INITIALIZER: Provider = {
    provide: APP_INITIALIZER,
    useFactory: () => initEncryption(inject(HttpApiService), inject(ENCRYPTION_MODE), inject(LOCATION_READY)),
    multi: true
};